import { asText, Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import type { JSX } from 'react';

/**
 * Props for `Html`.
 */
export type HtmlProps = SliceComponentProps<Content.HtmlSlice>;

/**
 * Component for "Html" Slices.
 */
const Html = ({ slice }: HtmlProps): JSX.Element => {
  return (
    <div
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      dangerouslySetInnerHTML={{ __html: asText(slice.primary.code) }}
    />
  );
};

export default Html;
